import { toast } from 'react-toastify';

function parseIsoDateLocal(isoDateStr) {
  const [year, month, day] = isoDateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
}

function formatDateToYYYYMMDD(date) {
  if (!(date instanceof Date) || Number.isNaN(date)) {
    throw new Error('Invalid Date');
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function generateInstallments({
  installmentNumbers,
  amount,
  dueDate,
  billingPayableId = null,
  billingReceivableId = null,
}) {
  const installments = [];

  if (!amount || !dueDate) return installments

  const numericInstallmentNumbers = Number(installmentNumbers);
  const numericAmount = Number(amount);
  const initialDate = parseIsoDateLocal(dueDate);

  if (!Number.isInteger(numericInstallmentNumbers) || numericInstallmentNumbers <= 0) {
    toast.warn('Número de parcelas deve ser um inteiro positivo.');
    return installments;
  }

  if (typeof numericAmount !== 'number' || Number.isNaN(numericAmount) || numericAmount <= 0) {
    toast.warn('Valor deve ser um número positivo.');
    return installments;
  }

  if (!(initialDate instanceof Date) || Number.isNaN(initialDate.getTime())) {
    toast.warn('Data de vencimento inválida ou em formato incorreto.');
    return installments;
  }

  const totalCents = Math.round(numericAmount * 100);
  const baseCents = Math.floor(totalCents / numericInstallmentNumbers);
  const remainder = totalCents - baseCents * numericInstallmentNumbers;

  const originalDay = initialDate.getDate();
  const startYear = initialDate.getFullYear();
  const startMonth = initialDate.getMonth(); // 0-indexed

  for (let i = 0; i < numericInstallmentNumbers; i += 1) {
    const targetMonth = startMonth + i;
    const year = startYear + Math.floor(targetMonth / 12);
    const month = targetMonth % 12;

    // Determine last day of this target month
    const lastDay = new Date(year, month + 1, 0).getDate();
    const adjustedDay = Math.min(originalDay, lastDay);
    const dueDateAdjusted = new Date(year, month, adjustedDay);

    const cents = i === numericInstallmentNumbers - 1 ? baseCents + remainder : baseCents;

    installments.push({
      installmentNumber: i + 1,
      dueDate: formatDateToYYYYMMDD(dueDateAdjusted),
      amount: cents / 100,
      amountPayed: null,
      paymentDate: null,
      billingPayableId,
      billingReceivableId,
    });
  }

  return installments;
}
